import React from 'react'
import { Icon } from './Calendar.elements'

type Props = {
  className?: string
}

export const CalendarIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 17 17"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M13.663 3.5H4.33c-.736 0-1.333.547-1.333 1.222v8.556c0 .675.597 1.222 1.333 1.222h9.333c.737 0 1.334-.547 1.334-1.222V4.722c0-.675-.597-1.222-1.334-1.222z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.997 1.5v4M5.997 1.5v4" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path d="M2.997 7.5h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </Icon>
)
